module.exports = __webpack_public_path__ + "static/media/click.79e5d2a1.svg";